import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronDown } from "lucide-react";
import { useSite } from "../lib/SiteContext";
import { mediaUrl } from "../lib/api";

const Hero = () => {
  const { content } = useSite();
  const h = content?.hero || {};

  return (
    <section className="relative min-h-screen flex items-end overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0">
        <img
          src={mediaUrl(h.image_url)}
          alt="Mediterranean boat charter Malta"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary/40 via-primary/20 to-primary/70" />
      </div>

      <div className="relative container-x w-full pb-20 md:pb-28 pt-32 text-white">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-8 animate-in-up">
            <div className="overline mb-6 text-sand" data-testid="hero-overline">
              {h.overline}
            </div>
            <h1
              className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-8xl tracking-tight leading-[0.95] text-balance"
              data-testid="hero-title"
            >
              {(h.title || "").split("\n").map((line, i) => (
                <span key={i} className="block">
                  {line}
                </span>
              ))}
            </h1>
          </div>
          <div className="lg:col-span-4 lg:pb-2 animate-in-up" style={{ animationDelay: "0.2s" }}>
            <p className="text-base md:text-lg text-white/85 leading-relaxed max-w-md" data-testid="hero-subtitle">
              {h.subtitle}
            </p>
            <div className="flex flex-wrap gap-3 mt-8">
              <Link
                to="/book"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-white text-primary font-medium tracking-wide hover:-translate-y-0.5 transition-all"
                style={{ borderRadius: "2px" }}
                data-testid="hero-primary-cta"
              >
                {h.primary_cta_label || "Book your charter"} <ArrowRight size={16} />
              </Link>
              <a
                href="#charters"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector("#charters")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="inline-flex items-center gap-2 px-7 py-3.5 border border-white/60 text-white hover:bg-white/10 transition-all"
                style={{ borderRadius: "2px" }}
                data-testid="hero-secondary-cta"
              >
                {h.secondary_cta_label || "View packages"}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 hidden md:flex items-center gap-6 text-xs tracking-[0.25em] uppercase text-white/70">
          <span className="h-px w-16 bg-white/40" />
          Sliema · Comino · Blue Lagoon · Gozo
          <ChevronDown size={14} className="ml-2 animate-bounce" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
